export const grade10Part6 = [
  {
    id: 'g10-pythagorean-theorem',
    title: 'Pythagorean Theorem and Applications',
    topic: 'Right Triangle Trigonometry',
    standard: 'CCSS.MATH.CONTENT.HSG.SRT.C.8',
    difficulty: 'medium',
    questions: [
      {
        id: 1,
        question: 'In a right triangle, if the legs are 5 and 12, what is the hypotenuse?',
        options: ['13', '17', '√119', '7'],
        correctAnswer: 0,
        solution: 'Pythagorean Theorem: a² + b² = c²\n\n5² + 12² = c²\n25 + 144 = c²\n169 = c²\nc = 13\n\nThis is a 5-12-13 Pythagorean triple.'
      },
      {
        id: 2,
        question: 'A right triangle has hypotenuse 10 and one leg 6. What is the other leg?',
        options: ['8', '4', '√64', '16'],
        correctAnswer: 0,
        solution: 'Pythagorean Theorem: a² + b² = c²\n\n6² + b² = 10²\n36 + b² = 100\nb² = 64\nb = 8\n\nThis is a 6-8-10 triangle (multiple of 3-4-5).'
      },
      {
        id: 3,
        question: 'Which set of numbers forms a Pythagorean triple?',
        options: ['8, 15, 17', '5, 10, 15', '7, 14, 21', '4, 5, 6'],
        correctAnswer: 0,
        solution: 'Check if a² + b² = c²:\n\nOption A: 8² + 15² = 64 + 225 = 289 = 17² ✓\nOption B: 5² + 10² = 25 + 100 = 125 ≠ 15² = 225 ✗\nOption C: 7² + 14² = 49 + 196 = 245 ≠ 21² = 441 ✗\nOption D: 4² + 5² = 16 + 25 = 41 ≠ 6² = 36 ✗\n\n8-15-17 is a Pythagorean triple.'
      },
      {
        id: 4,
        question: 'A ladder 25 feet long leans against a wall. The base is 7 feet from the wall. How high up the wall does it reach?',
        options: ['24 feet', '18 feet', '32 feet', '√576 feet'],
        correctAnswer: 0,
        solution: 'Right triangle:\n- Hypotenuse (ladder): 25 feet\n- Base: 7 feet\n- Height: h\n\n7² + h² = 25²\n49 + h² = 625\nh² = 576\nh = 24 feet\n\nThis is a 7-24-25 Pythagorean triple.'
      },
      {
        id: 5,
        question: 'What is the diagonal of a rectangle with length 9 and width 12?',
        options: ['15', '21', '√225', '3'],
        correctAnswer: 0,
        solution: 'Diagonal forms right triangle with length and width.\n\nd² = 9² + 12²\nd² = 81 + 144\nd² = 225\nd = 15\n\nThis is a 9-12-15 triangle (multiple of 3-4-5).'
      },
      {
        id: 6,
        question: 'In a 45-45-90 triangle, if the hypotenuse is 10√2, what is the length of each leg?',
        options: ['10', '5√2', '20', '5'],
        correctAnswer: 0,
        solution: '45-45-90 triangle ratios: leg : leg : hypotenuse = 1 : 1 : √2\n\nIf hypotenuse = 10√2, then:\nleg = hypotenuse/√2 = 10√2/√2 = 10\n\nBoth legs are 10.'
      },
      {
        id: 7,
        question: 'In a 30-60-90 triangle, if the shorter leg is 5, what is the hypotenuse?',
        options: ['10', '5√3', '15', '5√2'],
        correctAnswer: 0,
        solution: '30-60-90 triangle ratios:\nShorter leg : Longer leg : Hypotenuse = 1 : √3 : 2\n\nIf shorter leg = 5, then:\nHypotenuse = 2 × 5 = 10\n\nThe hypotenuse is twice the shorter leg.'
      },
      {
        id: 8,
        question: 'What is the distance from point (0, 0) to point (8, 15)?',
        options: ['17', '23', '√289', '7'],
        correctAnswer: 0,
        solution: 'Distance formula (Pythagorean theorem in coordinate plane):\n\nd = √[(8-0)² + (15-0)²]\nd = √[64 + 225]\nd = √289\nd = 17\n\nThis is an 8-15-17 Pythagorean triple.'
      },
      {
        id: 9,
        question: 'A square has diagonal 14. What is the side length?',
        options: ['7√2', '7', '14√2', '14'],
        correctAnswer: 0,
        solution: 'Square diagonal forms 45-45-90 triangle.\n\nIf side = s, then diagonal = s√2\n\ns√2 = 14\ns = 14/√2\ns = 14√2/2\ns = 7√2'
      },
      {
        id: 10,
        question: 'In a right triangle, if both legs are equal to 6, what is the hypotenuse?',
        options: ['6√2', '12', '6', '√72'],
        correctAnswer: 0,
        solution: 'Pythagorean Theorem:\n\n6² + 6² = c²\n36 + 36 = c²\n72 = c²\nc = √72 = √(36×2) = 6√2\n\nThis is a 45-45-90 triangle (isosceles right triangle).'
      },
      {
        id: 11,
        question: 'A baseball diamond is a square with sides 90 feet. What is the distance from home plate to second base?',
        options: ['90√2 feet', '180 feet', '90 feet', '45√2 feet'],
        correctAnswer: 0,
        solution: 'Distance is the diagonal of the square.\n\nd² = 90² + 90²\nd² = 8100 + 8100\nd² = 16200\nd = √16200 = 90√2 feet\n\nApproximately 127.3 feet.'
      },
      {
        id: 12,
        question: 'In a 30-60-90 triangle, if the longer leg is 12, what is the shorter leg?',
        options: ['4√3', '6', '12√3', '8'],
        correctAnswer: 0,
        solution: '30-60-90 ratios: 1 : √3 : 2\n\nLonger leg = shorter leg × √3\n12 = shorter leg × √3\nshorter leg = 12/√3 = 12√3/3 = 4√3\n\nThe shorter leg is 4√3.'
      },
      {
        id: 13,
        question: 'What is the length of the space diagonal of a rectangular box with dimensions 2, 3, and 6?',
        options: ['7', '11', '√49', '5'],
        correctAnswer: 0,
        solution: '3D Pythagorean Theorem: d² = l² + w² + h²\n\nd² = 2² + 3² + 6²\nd² = 4 + 9 + 36\nd² = 49\nd = 7\n\nThe space diagonal is 7.'
      },
      {
        id: 14,
        question: 'A right triangle has legs in ratio 3:4. If the hypotenuse is 20, what is the shorter leg?',
        options: ['12', '16', '15', '8'],
        correctAnswer: 0,
        solution: 'Legs in ratio 3:4 means this is a 3-4-5 triangle scaled up.\n\nIf hypotenuse = 20, scale factor = 20/5 = 4\n\nShorter leg = 3 × 4 = 12\nLonger leg = 4 × 4 = 16\n\nVerify: 12² + 16² = 144 + 256 = 400 = 20² ✓'
      },
      {
        id: 15,
        question: 'What is the altitude to the hypotenuse in a right triangle with legs 6 and 8?',
        options: ['4.8', '7', '10', '5'],
        correctAnswer: 0,
        solution: 'First find hypotenuse: c = √(6² + 8²) = √100 = 10\n\nArea method:\nArea = (1/2)(6)(8) = 24\nAlso: Area = (1/2)(hypotenuse)(altitude)\n24 = (1/2)(10)(h)\n24 = 5h\nh = 4.8\n\nAltitude to hypotenuse is 4.8.'
      },
      {
        id: 16,
        question: 'Which of the following is NOT a Pythagorean triple?',
        options: ['6, 8, 11', '5, 12, 13', '7, 24, 25', '9, 40, 41'],
        correctAnswer: 0,
        solution: 'Check each:\n\nA: 6² + 8² = 36 + 64 = 100 ≠ 11² = 121 ✗\nB: 5² + 12² = 25 + 144 = 169 = 13² ✓\nC: 7² + 24² = 49 + 576 = 625 = 25² ✓\nD: 9² + 40² = 81 + 1600 = 1681 = 41² ✓\n\n6-8-11 is NOT a Pythagorean triple.'
      },
      {
        id: 17,
        question: 'A right triangle has area 24 and one leg 6. What is the hypotenuse?',
        options: ['10', '8', '12', '14'],
        correctAnswer: 0,
        solution: 'Area = (1/2)(leg₁)(leg₂)\n24 = (1/2)(6)(leg₂)\n24 = 3(leg₂)\nleg₂ = 8\n\nNow find hypotenuse:\nc² = 6² + 8²\nc² = 36 + 64 = 100\nc = 10\n\nThis is a 6-8-10 triangle.'
      },
      {
        id: 18,
        question: 'In a 45-45-90 triangle, if each leg is 7, what is the hypotenuse?',
        options: ['7√2', '14', '7', '√98'],
        correctAnswer: 0,
        solution: '45-45-90 triangle: leg : leg : hypotenuse = 1 : 1 : √2\n\nIf leg = 7, then:\nHypotenuse = 7√2\n\nAlternatively: c² = 7² + 7² = 49 + 49 = 98\nc = √98 = 7√2'
      },
      {
        id: 19,
        question: 'What is the perimeter of a right triangle with legs 9 and 12?',
        options: ['36', '30', '21', '45'],
        correctAnswer: 0,
        solution: 'Find hypotenuse:\nc² = 9² + 12²\nc² = 81 + 144 = 225\nc = 15\n\nPerimeter = 9 + 12 + 15 = 36\n\nThis is a 9-12-15 triangle (multiple of 3-4-5).'
      },
      {
        id: 20,
        question: 'A right triangle has hypotenuse 13 and one leg 5. What is the area?',
        options: ['30', '65', '32.5', '60'],
        correctAnswer: 0,
        solution: 'Find other leg:\n5² + b² = 13²\n25 + b² = 169\nb² = 144\nb = 12\n\nArea = (1/2)(5)(12) = 30\n\nThis is a 5-12-13 Pythagorean triple.'
      },
      {
        id: 21,
        question: 'In a 30-60-90 triangle, if the hypotenuse is 20, what is the longer leg?',
        options: ['10√3', '10', '20√3', '5√3'],
        correctAnswer: 0,
        solution: '30-60-90 ratios: 1 : √3 : 2\n\nIf hypotenuse = 20, then:\nShorter leg = 20/2 = 10\nLonger leg = 10√3\n\nThe longer leg is √3 times the shorter leg.'
      },
      {
        id: 22,
        question: 'What is the diagonal of a cube with edge length 6?',
        options: ['6√3', '6√2', '12', '18'],
        correctAnswer: 0,
        solution: 'Space diagonal of cube: d = s√3\n\nd = 6√3\n\nAlternatively: d² = 6² + 6² + 6² = 36 + 36 + 36 = 108\nd = √108 = 6√3'
      },
      {
        id: 23,
        question: 'A right triangle has legs 20 and 21. What is the hypotenuse?',
        options: ['29', '41', '√841', '28'],
        correctAnswer: 0,
        solution: 'Pythagorean Theorem:\n\nc² = 20² + 21²\nc² = 400 + 441\nc² = 841\nc = 29\n\nThis is a 20-21-29 Pythagorean triple.'
      },
      {
        id: 24,
        question: 'If the diagonal of a rectangle is 25 and one side is 15, what is the other side?',
        options: ['20', '10', '√400', '5'],
        correctAnswer: 0,
        solution: 'Pythagorean Theorem:\n\n15² + b² = 25²\n225 + b² = 625\nb² = 400\nb = 20\n\nThis is a 15-20-25 triangle (multiple of 3-4-5).'
      },
      {
        id: 25,
        question: 'In a right triangle, if the altitude to the hypotenuse is 12 and divides the hypotenuse into segments of 9 and 16, what is the hypotenuse?',
        options: ['25', '21', '√337', '28'],
        correctAnswer: 0,
        solution: 'Hypotenuse = sum of segments\n\nHypotenuse = 9 + 16 = 25\n\nGeometric Mean Altitude Theorem:\naltitude² = segment₁ × segment₂\n12² = 9 × 16\n144 = 144 ✓'
      },
      {
        id: 26,
        question: 'What is the length of the diagonal of a square with area 50?',
        options: ['10', '5√2', '√100', '7.07'],
        correctAnswer: 0,
        solution: 'Area = s² = 50\ns = √50 = 5√2\n\nDiagonal = s√2 = 5√2 × √2 = 5 × 2 = 10\n\nThe diagonal is 10.'
      },
      {
        id: 27,
        question: 'A right triangle has perimeter 30 and hypotenuse 13. What is the area?',
        options: ['30', '60', '15', '65'],
        correctAnswer: 0,
        solution: 'Let legs be a and b.\na + b + 13 = 30\na + b = 17\n\nAlso: a² + b² = 13² = 169\n\n(a + b)² = a² + 2ab + b²\n17² = 169 + 2ab\n289 = 169 + 2ab\n120 = 2ab\nab = 60\n\nArea = (1/2)ab = (1/2)(60) = 30'
      },
      {
        id: 28,
        question: 'In a 45-45-90 triangle, if the hypotenuse is 20, what is the area?',
        options: ['100', '200', '50', '400'],
        correctAnswer: 0,
        solution: '45-45-90 triangle: leg = hypotenuse/√2\n\nleg = 20/√2 = 20√2/2 = 10√2\n\nArea = (1/2)(leg)(leg)\nArea = (1/2)(10√2)(10√2)\nArea = (1/2)(100 × 2)\nArea = 100'
      },
      {
        id: 29,
        question: 'What is the shortest distance from point (3, 4) to the line y = 0?',
        options: ['4', '3', '5', '7'],
        correctAnswer: 0,
        solution: 'Distance from point to x-axis (y = 0) is the absolute value of the y-coordinate.\n\nDistance = |4| = 4\n\nThe perpendicular distance is 4 units.'
      },
      {
        id: 30,
        question: 'A right triangle has legs in ratio 5:12. If the area is 120, what is the hypotenuse?',
        options: ['26', '13', '52', '24'],
        correctAnswer: 0,
        solution: 'Let legs be 5x and 12x.\n\nArea = (1/2)(5x)(12x) = 30x² = 120\nx² = 4\nx = 2\n\nLegs: 5(2) = 10 and 12(2) = 24\n\nHypotenuse: c² = 10² + 24² = 100 + 576 = 676\nc = 26\n\nThis is a 10-24-26 triangle (multiple of 5-12-13).'
      }
    ]
  },
  {
    id: 'g10-state-test-prep',
    title: 'Geometry State Test Preparation',
    topic: 'State Test Prep',
    standard: 'Common Core & State Standards',
    difficulty: 'hard',
    questions: [
      {
        id: 1,
        question: 'Which transformation maps △ABC with vertices A(1,2), B(3,4), C(2,5) to △A\'B\'C\' with vertices A\'(-1,2), B\'(-3,4), C\'(-2,5)?',
        options: ['Reflection across y-axis', 'Reflection across x-axis', 'Rotation 180°', 'Translation left 2'],
        correctAnswer: 0,
        solution: 'Compare coordinates:\nA(1,2) → A\'(-1,2): x changes sign, y stays same\nB(3,4) → B\'(-3,4): x changes sign, y stays same\nC(2,5) → C\'(-2,5): x changes sign, y stays same\n\nPattern: (x,y) → (-x,y)\n\nThis is reflection across the y-axis.'
      },
      {
        id: 2,
        question: 'In circle O, chord AB is 16 cm and is 6 cm from the center. What is the radius?',
        options: ['10 cm', '8 cm', '12 cm', '14 cm'],
        correctAnswer: 0,
        solution: 'Perpendicular from center bisects chord.\nHalf-chord = 8 cm\n\nRight triangle:\nr² = 6² + 8²\nr² = 36 + 64 = 100\nr = 10 cm\n\nThis is a 6-8-10 triangle.'
      },
      {
        id: 3,
        question: 'Triangle ABC ~ Triangle DEF with scale factor 3:5. If the area of △ABC is 27 cm², what is the area of △DEF?',
        options: ['75 cm²', '45 cm²', '135 cm²', '15 cm²'],
        correctAnswer: 0,
        solution: 'Linear scale factor: 3:5\nArea scale factor: (3:5)² = 9:25\n\n27/A = 9/25\n9A = 675\nA = 75 cm²\n\nArea scales with the square of the linear scale.'
      },
      {
        id: 4,
        question: 'What is the volume of a cone with radius 9 cm and height 12 cm?',
        options: ['324π cm³', '972π cm³', '108π cm³', '648π cm³'],
        correctAnswer: 0,
        solution: 'Volume of cone: V = (1/3)πr²h\n\nV = (1/3)π(9²)(12)\nV = (1/3)π(81)(12)\nV = (1/3)(972π)\nV = 324π cm³'
      },
      {
        id: 5,
        question: 'In right triangle ABC with right angle at C, if sin A = 0.6 and AB = 15, what is BC?',
        options: ['9', '12', '10', '8'],
        correctAnswer: 0,
        solution: 'sin A = opposite/hypotenuse = BC/AB\n\n0.6 = BC/15\nBC = 15 × 0.6 = 9\n\nThe opposite side is 9.'
      },
      {
        id: 6,
        question: 'What is the equation of a circle with center (-2, 3) and radius 7?',
        options: ['(x+2)² + (y-3)² = 49', '(x-2)² + (y+3)² = 49', '(x+2)² + (y-3)² = 7', '(x-2)² + (y+3)² = 7'],
        correctAnswer: 0,
        solution: 'Circle equation: (x-h)² + (y-k)² = r²\n\nCenter: (h,k) = (-2, 3)\nRadius: r = 7\n\n(x-(-2))² + (y-3)² = 7²\n(x+2)² + (y-3)² = 49'
      },
      {
        id: 7,
        question: 'Given: AB ≅ DE, BC ≅ EF, ∠B ≅ ∠E. Which congruence criterion proves △ABC ≅ △DEF?',
        options: ['SAS', 'ASA', 'SSS', 'AAS'],
        correctAnswer: 0,
        solution: 'Given:\n• AB ≅ DE (side)\n• ∠B ≅ ∠E (angle between the sides)\n• BC ≅ EF (side)\n\nPattern: Side-Angle-Side\n\nCongruence: SAS'
      },
      {
        id: 8,
        question: 'What is the distance between points (2, -3) and (10, 3)?',
        options: ['10', '8', '√100', '14'],
        correctAnswer: 0,
        solution: 'Distance formula:\n\nd = √[(10-2)² + (3-(-3))²]\nd = √[8² + 6²]\nd = √[64 + 36]\nd = √100\nd = 10\n\nThis is a 6-8-10 triangle.'
      },
      {
        id: 9,
        question: 'An inscribed angle intercepts an arc of 120°. What is the measure of the inscribed angle?',
        options: ['60°', '120°', '240°', '30°'],
        correctAnswer: 0,
        solution: 'Inscribed Angle Theorem:\nInscribed angle = (1/2) × intercepted arc\n\nAngle = 120° ÷ 2 = 60°\n\nInscribed angles are half their arcs.'
      },
      {
        id: 10,
        question: 'What is the surface area of a sphere with diameter 12 cm?',
        options: ['144π cm²', '288π cm²', '36π cm²', '576π cm²'],
        correctAnswer: 0,
        solution: 'Diameter = 12 cm, so radius = 6 cm\n\nSurface area: SA = 4πr²\n\nSA = 4π(6²)\nSA = 4π(36)\nSA = 144π cm²'
      },
      {
        id: 11,
        question: 'In △ABC, DE ∥ BC with D on AB and E on AC. If AD = 6, DB = 9, and AE = 8, what is EC?',
        options: ['12', '10', '14', '16'],
        correctAnswer: 0,
        solution: 'Side-Splitter Theorem:\nAD/DB = AE/EC\n\n6/9 = 8/EC\n6 × EC = 9 × 8\n6 × EC = 72\nEC = 12'
      },
      {
        id: 12,
        question: 'What is the slope of a line perpendicular to 3x + 4y = 12?',
        options: ['4/3', '-4/3', '3/4', '-3/4'],
        correctAnswer: 0,
        solution: 'Convert to slope-intercept form:\n4y = -3x + 12\ny = (-3/4)x + 3\n\nOriginal slope: m₁ = -3/4\nPerpendicular slope: m₂ = -1/m₁ = -1/(-3/4) = 4/3'
      },
      {
        id: 13,
        question: 'A pyramid has a square base with side 10 cm and height 12 cm. What is its volume?',
        options: ['400 cm³', '1200 cm³', '600 cm³', '200 cm³'],
        correctAnswer: 0,
        solution: 'Volume of pyramid: V = (1/3)Bh\n\nBase area: B = 10² = 100 cm²\nV = (1/3)(100)(12)\nV = (1/3)(1200)\nV = 400 cm³'
      },
      {
        id: 14,
        question: 'In a 30-60-90 triangle, if the shorter leg is 7, what is the longer leg?',
        options: ['7√3', '14', '7√2', '14√3'],
        correctAnswer: 0,
        solution: '30-60-90 ratios: 1 : √3 : 2\n\nShorter leg : Longer leg = 1 : √3\n\nIf shorter leg = 7, then:\nLonger leg = 7√3'
      },
      {
        id: 15,
        question: 'What is the midpoint of the segment from (-4, 7) to (6, -3)?',
        options: ['(1, 2)', '(2, 4)', '(5, 5)', '(1, 5)'],
        correctAnswer: 0,
        solution: 'Midpoint formula:\n\nM = ((x₁+x₂)/2, (y₁+y₂)/2)\nM = ((-4+6)/2, (7+(-3))/2)\nM = (2/2, 4/2)\nM = (1, 2)'
      },
      {
        id: 16,
        question: 'Two chords intersect inside a circle. If the segments of one chord are 4 and 9, and one segment of the other is 6, what is the other segment?',
        options: ['6', '5', '8', '12'],
        correctAnswer: 0,
        solution: 'Intersecting Chords Theorem:\na × b = c × d\n\n4 × 9 = 6 × x\n36 = 6x\nx = 6'
      },
      {
        id: 17,
        question: 'What is the area of a regular hexagon with side length 6?',
        options: ['54√3', '36√3', '108√3', '27√3'],
        correctAnswer: 0,
        solution: 'Regular hexagon area: A = (3√3/2)s²\n\nA = (3√3/2)(6²)\nA = (3√3/2)(36)\nA = 54√3\n\nAlternatively: 6 equilateral triangles, each with area (√3/4)(36) = 9√3\nTotal: 6 × 9√3 = 54√3'
      },
      {
        id: 18,
        question: 'If cos θ = 12/13, what is tan θ?',
        options: ['5/12', '12/5', '5/13', '13/5'],
        correctAnswer: 0,
        solution: 'cos θ = adjacent/hypotenuse = 12/13\n\nRight triangle:\n- Adjacent = 12\n- Hypotenuse = 13\n- Opposite = √(13² - 12²) = √(169 - 144) = √25 = 5\n\ntan θ = opposite/adjacent = 5/12\n\nThis is a 5-12-13 triangle.'
      },
      {
        id: 19,
        question: 'What is the total surface area of a cylinder with radius 5 cm and height 8 cm?',
        options: ['130π cm²', '80π cm²', '50π cm²', '40π cm²'],
        correctAnswer: 0,
        solution: 'Total surface area: SA = 2πr² + 2πrh\n\nSA = 2π(5²) + 2π(5)(8)\nSA = 2π(25) + 2π(40)\nSA = 50π + 80π\nSA = 130π cm²'
      },
      {
        id: 20,
        question: 'Triangle ABC has vertices A(0,0), B(6,0), C(3,6). What type of triangle is it?',
        options: ['Isosceles', 'Equilateral', 'Scalene', 'Right'],
        correctAnswer: 0,
        solution: 'Find side lengths:\nAB = 6\nAC = √(3² + 6²) = √(9 + 36) = √45 = 3√5\nBC = √((6-3)² + (0-6)²) = √(9 + 36) = √45 = 3√5\n\nAC = BC, so triangle is isosceles.\n\nNot equilateral (AB ≠ AC)\nNot right (6² ≠ (3√5)² + (3√5)²)'
      },
      {
        id: 21,
        question: 'What is the length of an arc with central angle 45° in a circle with radius 8?',
        options: ['2π', 'π', '4π', '8π'],
        correctAnswer: 0,
        solution: 'Arc length: s = (θ/360°) × 2πr\n\ns = (45°/360°) × 2π(8)\ns = (1/8) × 16π\ns = 2π\n\nAlternatively: 45° = π/4 radians\ns = rθ = 8(π/4) = 2π'
      },
      {
        id: 22,
        question: 'In parallelogram ABCD, if ∠A = 65°, what is ∠C?',
        options: ['65°', '115°', '130°', '25°'],
        correctAnswer: 0,
        solution: 'Parallelogram properties:\n• Opposite angles are congruent\n• Consecutive angles are supplementary\n\n∠A and ∠C are opposite angles.\n\n∠C = ∠A = 65°'
      },
      {
        id: 23,
        question: 'What is the diagonal of a rectangular prism with dimensions 3, 4, and 12?',
        options: ['13', '19', '√169', '15'],
        correctAnswer: 0,
        solution: '3D distance formula:\nd² = 3² + 4² + 12²\nd² = 9 + 16 + 144\nd² = 169\nd = 13\n\nThe space diagonal is 13.'
      },
      {
        id: 24,
        question: 'If △ABC ~ △DEF with AB = 6, DE = 9, and the perimeter of △ABC is 18, what is the perimeter of △DEF?',
        options: ['27', '12', '36', '24'],
        correctAnswer: 0,
        solution: 'Scale factor: AB/DE = 6/9 = 2/3\n\nPerimeter ratio = scale factor = 2/3\n\n18/P = 2/3\n2P = 54\nP = 27\n\nPerimeter of △DEF is 27.'
      },
      {
        id: 25,
        question: 'What is the area of a sector with central angle 120° in a circle with radius 9?',
        options: ['27π', '81π', '54π', '9π'],
        correctAnswer: 0,
        solution: 'Sector area: A = (θ/360°) × πr²\n\nA = (120°/360°) × π(9²)\nA = (1/3) × 81π\nA = 27π\n\nThe sector is 1/3 of the circle.'
      },
      {
        id: 26,
        question: 'In right triangle ABC with right angle at C, if tan A = 3/4, what is sin A?',
        options: ['3/5', '4/5', '3/4', '4/3'],
        correctAnswer: 0,
        solution: 'tan A = opposite/adjacent = 3/4\n\nRight triangle:\n- Opposite = 3\n- Adjacent = 4\n- Hypotenuse = √(9 + 16) = 5\n\nsin A = opposite/hypotenuse = 3/5\n\nThis is a 3-4-5 triangle.'
      },
      {
        id: 27,
        question: 'What is the volume of a sphere with surface area 144π cm²?',
        options: ['288π cm³', '144π cm³', '576π cm³', '432π cm³'],
        correctAnswer: 0,
        solution: 'Surface area: 4πr² = 144π\n4r² = 144\nr² = 36\nr = 6 cm\n\nVolume: V = (4/3)πr³\nV = (4/3)π(6³)\nV = (4/3)π(216)\nV = 288π cm³'
      },
      {
        id: 28,
        question: 'What is the equation of the perpendicular bisector of the segment from (1, 2) to (7, 6)?',
        options: ['y = -3/2x + 10', 'y = 2/3x + 2', 'y = -3/2x + 4', 'y = 2/3x + 4'],
        correctAnswer: 0,
        solution: 'Midpoint: M = ((1+7)/2, (2+6)/2) = (4, 4)\n\nSlope of segment: m₁ = (6-2)/(7-1) = 4/6 = 2/3\nPerpendicular slope: m₂ = -3/2\n\nEquation through (4, 4):\ny - 4 = (-3/2)(x - 4)\ny - 4 = (-3/2)x + 6\ny = (-3/2)x + 10'
      },
      {
        id: 29,
        question: 'In a rhombus with diagonals 16 and 12, what is the side length?',
        options: ['10', '14', '8', '√244'],
        correctAnswer: 0,
        solution: 'Rhombus diagonals bisect each other at right angles.\n\nHalf-diagonals: 8 and 6\n\nSide = √(8² + 6²)\nSide = √(64 + 36)\nSide = √100\nSide = 10\n\nThis is a 6-8-10 triangle.'
      },
      {
        id: 30,
        question: 'What is the volume of a hemisphere with diameter 12 cm?',
        options: ['144π cm³', '288π cm³', '72π cm³', '216π cm³'],
        correctAnswer: 0,
        solution: 'Diameter = 12 cm, so radius = 6 cm\n\nHemisphere volume: V = (2/3)πr³\n\nV = (2/3)π(6³)\nV = (2/3)π(216)\nV = 144π cm³\n\nHemisphere is half a sphere.'
      }
    ]
  }
];